import { Fragment } from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../store/store";
import { Role } from "../types";

type Props = {
  children: React.ReactNode;
  roles: Role[];
};

export default function AuthMiddleware({ children, roles }: Props) {
  const { token, siteRole } = useAppSelector((state) => state.login);
  // const location = useLocation();
  // const path = pathLink(location.pathname, 1);

  const accessRole = siteRole && roles?.length && roles?.includes(siteRole);

  return token ? (
    accessRole ? (
      <Fragment>{children}</Fragment>
    ) : (
      <Navigate to="/404" replace />
    )
  ) : (
    <Navigate to="/login" replace />
  );
}
